import 'jquery';
import 'slick-carousel';
import 'jquery-mask-plugin';
import mediumZoom from 'medium-zoom'

export default {
  init() {
    var $windowWidth = $(window).width();
    var zoom = mediumZoom('[data-zoomable]');
    var zoomBtn = mediumZoom('[data-zoomable-btn]');

    $.fn.offScreen = function (distance) {
      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top - distance,
        _bottom = $t.offset().top + $t.height() + distance;

      return {
        top: _bottom <= viewTop,
        bottom: _top >= viewBottom,
      };
    };

    var win = $(window);

    var allMods = $('[js-smooth-load]');
    var allModsAlt = $('[js-smooth-load-alt]');

    allMods.each(function (i, el) {
      el = $(document).find(el);
      if (!el.offScreen(15).bottom) {
        el.addClass('already-visible');
      }
    });

    allModsAlt.each(function (i, el) {
      el = $(document).find(el);
      //console.log(el);
      if (!el.offScreen(15).bottom) {
        el.addClass('already-visible');
      }
    });

    win.on('scroll resize', function () {
      allMods.each(function (i, el) {
        el = $(document).find(el);
        if (!el.offScreen(15).bottom) {
          el.removeClass('already-visible off-screen-bottom');
          el.addClass('come-in');
        } else {
          el.addClass('off-screen-bottom');
        }
      }); //allMods.each()
      allModsAlt.each(function (i, el) {
        el = $(document).find(el);
        if (!el.offScreen(15).bottom) {
          el.removeClass('already-visible off-screen-bottom');
          el.addClass('come-in-alt');
        } else {
          el.addClass('off-screen-bottom');
        }
      }); //allMods.each()
    }); //win.scroll()

    win.trigger('scroll');


    // mobile run
    if ($windowWidth < 1166) {
      $('[js-slick-badges]').slick({
        arrows: false,
        infinite: true,
        lazyLoad: 'ondemand',
        autoplay: false,
        pauseOnHover: false,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        dotsClass: 'slick-dots slick-dots--badges',
      });

      $('[js-slick-related-blog]').slick({
        arrows: true,
        infinite: true,
        lazyLoad: 'ondemand',
        autoplay: false,
        pauseOnHover: false,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      });

      $('[js-slick-home-features]').slick({
        arrows: true,
        infinite: true,
        lazyLoad: 'ondemand',
        autoplay: false,
        pauseOnHover: false,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      });

      $('[js-slick-product-images]').slick({
        arrows: false,
        infinite: true,
        lazyLoad: 'ondemand',
        autoplay: false,
        pauseOnHover: false,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        dotsClass: 'slick-dots slick-dots--badges',
      });
    }

    $('[js-menu-mobile-open]').on('click', function (e) {
      e.preventDefault();
      $('[js-menu-mobile], [js-menu-mobile-toggle]').toggleClass('opened');
      $('[js-menu-mobile-submenu]').removeClass('opened');
    });

    $('[js-menu-mobile-has-submenu]').on('click', function (e) {
      e.preventDefault();
      $(this).next().toggleClass('opened');
    });

    $('[js-modal-open]').on('click', function (e) {
      e.preventDefault();
      $('[js-modal]').addClass('show');
    });

    $('[js-modal-close]').on('click', function (e) {
      e.preventDefault();
      $('[js-modal]').removeClass('show');
    });

    // REVISAR

    $('.line-list').slick({
      dots: true,
      arrows: false,
      infinite: true,
      lazyLoad: 'ondemand',
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 600,
      slidesToShow: 2,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            infinite: true,
          },
        },
      ],
    });

    $('.testimonial-list').slick({
      dots: false,
      arrows: true,
      infinite: true,
      lazyLoad: 'ondemand',
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      focusOnSelect: true,
      adaptiveHeight: true,
    });

    $('.eat-list').slick({
      dots: false,
      arrows: true,
      infinite: true,
      lazyLoad: 'ondemand',
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      speed: 600,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      focusOnSelect: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            infinite: true,
          },
        },
      ],
    });

    $('.way-list').slick({
      dots: false,
      arrows: true,
      infinite: true,
      lazyLoad: 'ondemand',
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
    });

    $('.slider--blog').slick({
      dots: true,
      arrows: false,
      infinite: true,
      lazyLoad: 'ondemand',
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      adaptiveHeight: true,
    });

    $('.faq-list__title').on('click', function(){
        var elem = $(this).attr('id');
        $(this).toggleClass('faq-list__title--active');
        $('#'+elem+' + .faq-list__text').slideToggle();
    });

    $('.c-search-bar__form').on('click', '.c-search-bar__select-mask' ,function(){
        var target = $(this).data('target');
        $('#drop-down-'+target).slideToggle();
        console.log(target);
    });

    $('[js-select-option-cat]').on('click', function(){
      $('#drop-down-category').slideUp();
      $('#input-cat').val($(this).data('id'));
      $('[js-select-option-cat-host]').html($(this).html());
    });

    $('[js-select-option-tag]').on('click', function(){
      $('#drop-down-tag').slideUp();
      $('#input-tag').val($(this).data('id'));
      $('[js-select-option-tag-host]').html($(this).html());
    });

    $('[js-select-option-autor]').on('click', function(){
      $('#drop-down-autor').slideUp();
      $('#input-autor').val($(this).data('id'));
      $('[js-select-option-autor-host]').html($(this).html());
    });

    $('[ingredients-nav]').on('click', function () {

      $('[ingredients-nav]').removeClass(
        'ingredients-tabs__tab-selector--active'
      );
      $(this).addClass('ingredients-tabs__tab-selector--active');

      $('[ingredients-content]').removeClass('ingredients-tabs__item--active');
      $(
        '[ingredients-content="' + $(this).attr('ingredients-nav') + '"]'
      ).addClass('ingredients-tabs__item--active');

    });

    $('[js-sidebar-title]').on('click', function () {
      $(this).toggleClass('closed');
      $(this).next().slideToggle();
    });

    $('[js-product-image-thumb]').on('click', function () {
      var imgOriginal = $(this).data('image');
      var imgZoom = $(this).data('image-zoom');

      $('[js-product-image-thumb]').removeClass('active');
      $(this).addClass('active');

      console.log('sourve: ', $('.product-info__figure').find('source'));
      $('.product-info__figure').find('source').remove();

      $('[js-product-image]').attr('src', imgOriginal);
      $('[js-product-image]').attr('data-zoom-src', imgZoom);
      $('[js-product-image]').attr('data-zoom-src', imgZoom);
      $('[js-product-image-zoom-btn]').attr('data-zoom-src', imgZoom);
      $('[js-product-image-zoom-btn]').attr('src', imgZoom);
      $('[js-product-image-zoom-btn]').attr('data-data-zoom-src', imgZoom);

      zoom.update();
      zoomBtn.update();
    });

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 500) {
        $('.header__logo').addClass('header__logo--scrolled');
      } else {
        $('.header__logo').removeClass('header__logo--scrolled');
      }

      var windowHeight = $(window).height();
      var scrollTop = $(window).scrollTop();
      var mid = scrollTop + Math.floor(windowHeight / 2);
      var element = $('[js-features-hover-set]');

      if (element.length) {
        var elementHeight = $('[js-features-hover]').height();
        var elementOffset = $('[js-features-hover]').offset().top;
        if (mid > elementOffset) {
          let diff = mid - elementOffset;
          diff = 100 - (100 * diff) / elementHeight;
          element.css('height', diff + '%');
        }
      }

      $('[js-scroll-image]').each(function () {
        if (mid > $(this).offset().top) {
          $(this).addClass('js-scrolled');
        }
      });
    });

    function scrollToId(hash) {
      var dest = 0;
      if (
        $(hash).offset().top >
        $(document).height() - $(window).height()
      ) {
        dest = $(document).height() - $(window).height();
      } else {
        dest = $(hash).offset().top;
      }

      dest -= 80;

      $('html,body').animate({ scrollTop: dest }, 1000, 'swing');
    }

    $('a.anchor').on('click', function (event) {
      event.preventDefault();
      scrollToId(this.hash);
    });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const paramId = urlParams.get('id');
    const paramPostType = urlParams.get('post_type');

    if(paramId) {
      scrollToId('#lojas-fisicas');
      scrollToId('#lojas-fisicas');
    }

    if(paramPostType) {
      scrollToId('#scroll-to-result');
      scrollToId('#scroll-to-result');
    }

    $('#form-filter .input__checkbox').on('change', function(e){
      e.preventDefault();
      $('#form-filter').submit();
    })


    $('[js-share-show]').on('click', function () {
      $('[js-share]').slideToggle();
    });

    const cellMask = function (val) {
      return val.replace(/\D/g, '').length === 11 ? '(00) 00000.0000' : '(00) 0000.00009';
    },

      cellOptions = {
        onKeyPress: function (val, e, field, options) {
          field.mask(cellMask.apply({}, arguments), options);
        }
      },

      cpfOptions = {
        onKeyPress: function (val, e, field, options) {
          field.mask(cpfMask.apply({}, arguments), options);
        }
      };

    $('.js-cell').mask(cellMask, cellOptions);

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js